import { chartColors } from "@/components/charts/chartTheme";
import { formatSignedPercentage } from "@/lib/format";

interface TrendBadgeProps {
  /** Signed percentage delta, e.g. 1.8 for +1.8%, -0.4 for -0.4%. */
  delta: number;
  precision?: number;
}

/**
 * Not a recharts component — a small arrow + colored signed-percentage
 * label computed client-side from two data points (e.g. today vs
 * yesterday). Color and arrow direction both derive from the sign of
 * delta, so the two never disagree.
 */
export function TrendBadge({ delta, precision = 1 }: TrendBadgeProps) {
  const isPositive = delta > 0;
  const isNegative = delta < 0;
  const color = isPositive ? chartColors.positive : isNegative ? chartColors.negative : chartColors.neutralLine;

  return (
    <span
      className="font-numeric"
      style={{ display: "inline-flex", alignItems: "center", gap: 4, color, fontSize: "0.8125rem", fontWeight: 600 }}
    >
      {isPositive ? (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
          <path d="M5 8V2M2 5l3-3 3 3" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : isNegative ? (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
          <path d="M5 2v6M2 5l3 3 3-3" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : null}
      {formatSignedPercentage(delta, precision)}
    </span>
  );
}
